import React from "react";
import { useTranslation } from "react-i18next";
import {
  ScreeningDto,
  TelecommunicationDtoMethodEnum,
} from "@docket/consumer-app-client-typescript-axios";
import { getDateTime } from "../utils/data";

interface EventCardProps {
  index: number;
  screeningEvent: ScreeningDto;
}

export default function ScreeningEventCard({ screeningEvent, index }: EventCardProps) {
  const { t } = useTranslation();

  const readableDate = (date: string) => {
    return getDateTime(date).toLocaleString();
  };

  const hasOrderingFacilityData =
    screeningEvent.orderingFacility &&
    (screeningEvent.orderingFacility.names.length > 0 ||
      screeningEvent.orderingFacility.contactInfo.length > 0);

  return (
    <div className="p-4 event-card flex flex-col max-md:bg-white">
      {screeningEvent.testDate && (
        <div
          role="paragraph"
          className="text-dark font-black text-xl"
          data-testid="event-card-title"
        >
          {readableDate(screeningEvent.testDate)}
        </div>
      )}
      {screeningEvent.type && (
        <div role="paragraph" className="text-dark flex text-md" data-testid="event-card-specimen">
          <p className="font-black">{t("screening.records_event_specimen")}</p>
          &nbsp;
          <p className="font-semibold">
            {t("screening.results_lead", { context: screeningEvent.type })}
          </p>
        </div>
      )}
      {screeningEvent.measurement && (
        <div
          role="paragraph"
          className="text-dark flex text-md"
          data-testid="event-card-test-value"
        >
          <p className="font-black">{t("screening.records_event_test_value")}</p>
          &nbsp;
          <p className="font-semibold">
            {screeningEvent.measurement + " "}
            {screeningEvent.units ? screeningEvent.units : ""}
          </p>
        </div>
      )}
      {screeningEvent?.laboratory && (
        <div
          role="paragraph"
          className="text-dark flex text-md"
          data-testid="event-card-reference-value"
        >
          <p className="font-black">{t("screening.records_event_laboratory")}</p>
          &nbsp;
          <p className="font-semibold">{screeningEvent.laboratory}</p>
        </div>
      )}
      {hasOrderingFacilityData && (
        <div
          role="paragraph"
          className="text-dark font-black text-md"
          data-testid="event-card-ordering-facility"
        >
          <b>{t("screening.records_event_ordering_facility")}</b>
          <span className="font-semibold">{screeningEvent.orderingFacility.names.join(", ")}</span>
          {screeningEvent.orderingFacility.contactInfo.map((contact, index) => (
            <>
              {contact.method !== TelecommunicationDtoMethodEnum.Unknown && (
                <div key={contact.value}>
                  <b>
                    {t(`screening.records_event_contact`, {
                      context: contact.method.toLowerCase(),
                    })}
                  </b>{" "}
                  <span className="font-semibold">{contact.value}</span>
                </div>
              )}
            </>
          ))}
        </div>
      )}
    </div>
  );
}
